module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container is-fluid container-margin-top"
  }, [_c('div', {
    staticClass: "content content-padding"
  }, [_c('h1', [_vm._v("Screensaver do Coche")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [(_vm.coach && _vm.coach.screensaver_path) ? _c('div', {
    staticClass: "column is-half"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Video")]), _vm._v(" "), _c('video', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.screensaverLocation + _vm.coach.screensaver_path,
      "type": "video/mp4"
    }
  }), _vm._v("\n          Your browser does not support the video tag.\n        ")])]) : _vm._e()]), _vm._v(" "), (_vm.coach && !_vm.coach.screensaver_path) ? _c('a', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.openCoachScreensaverModal
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Adicionar")])]) : _vm._e(), _vm._v(" "), (_vm.coach && _vm.coach.screensaver_path) ? _c('a', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.openCoachScreensaverModal
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Editar")])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a17b6ce4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Coach/CoachScreensaver.vue
// module id = 345
// module chunks = 1